import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { OrganisationsService } from '../../services/organisations.service';
import { CommsEventService } from '../../services/comms-event.service';
import { ICommsEvent } from '../../interfaces/comms-event';
import { SelectItem } from 'primeng';
import { MergeModelName } from '../../interfaces/comms-template/comms-merge-model';

@Component({
  selector: 'comms-event',
  styleUrls: ['./comms-event.component.scss'],
  templateUrl: 'comms-event.component.html',
})
export class CommsEventComponent implements OnInit {
  public mergeModelChoices: {}[] = [];
  public selectedItem: ICommsEvent;
  public isLoaded: true;
  public showEditForm: boolean = false;
  public editMode: boolean = false;
  public loading: false;
  public formGroup: UntypedFormGroup;
  public MergeModelName = MergeModelName;

  @Input() commsEvents: ICommsEvent[];

  constructor(
    private commsEventService: CommsEventService,
    private formBuilder: UntypedFormBuilder,
    private organisationsService: OrganisationsService,
  ) {}

  async ngOnInit() {
    console.log('EVENT COMPONENT INIT');

    this.buildForm();
    this.fetchMergeModelChoices();
    this.fetchCommEvents();
  }

  fetchCommEvents() {
    this.commsEventService.getCommsEvents().then((x) => {
      x.forEach((ev) => {
        ev.mergeModelName = this.MergeModelName[ev.mergeModel];
      });

      this.commsEvents = x;
    });
  }

  isEditMode() {
    return this.editMode;
  }

  fetchMergeModelChoices() {
    this.mergeModelChoices = [];

    var choiceList: SelectItem[] = [];

    for (const [key, value] of Object.entries(MergeModelName)) {
      choiceList.push({ value: key, label: value });
    }

    var x = choiceList.sort((a: SelectItem, b: SelectItem) => a.label.localeCompare(b.label));

    x.unshift({ value: null, label: 'Select Model' });

    this.mergeModelChoices = x;
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      id: [''],
      mergeModel: [''],
      commsEventCode: [''],
      title: [''],
      description: [''],
      active: [''],
    });
  }

  canSave() {
    var f = this.formGroup.value;

    return f.commsEventCode && f.commsEventCode.length > 0 && f.title && f.title.length > 0;
  }

  async save() {
    var f = this.formGroup.value;

    var saveObject = <ICommsEvent>{
      id: f.id,
      commsEventCode: f.commsEventCode,
      title: f.title,
      description: f.description,
      active: f.active,
      mergeModel: f.mergeModel,
    };

    this.commsEventService.saveEvent({ commsEvent: saveObject }).then((x) => {
      this.fetchCommEvents();
      this.showEditForm = false;
    });
  }

  async delete() {
    await this.commsEventService.deleteEvent(this.selectedItem.id);

    this.fetchCommEvents();
  }

  async edit() {
    this.showEditForm = true;
    this.editMode = true;

    var t = this.selectedItem;

    await this.patchForm(t);
  }

  async patchForm(t) {
    this.formGroup.patchValue({
      id: t.id,
      title: t.title,
      description: t.description,
      commsEventCode: t.commsEventCode,
      mergeModel: t.mergeModel,
      active: t.active,
    });
  }

  get f() {
    return this.formGroup.value;
  }

  async add() {
    this.showEditForm = true;
    this.editMode = false;

    var t = {
      id: 0,
      commsEventCode: '',
      mergeModelId: null,
      title: '',
      description: '',
      active: true,
    };

    await this.patchForm(t);
  }

  title = 'comms-event';
}
